import cx from 'classnames';
import { canUseDOM } from 'exenv';
import { t } from 'i18next';
import { FC, MouseEventHandler, useMemo } from 'react';

type TDownloadButtonProps = {
  style?: any;
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const DownloadButton: FC<TDownloadButtonProps> = (props) => {
  const platformIcon = useMemo(() => {
    let platform = 'fa-windows';
    if (canUseDOM) {
      const ua = navigator.userAgent || '';
      if (ua.indexOf('Mac') !== -1 || ua.indexOf('Darwin') !== -1) {
        platform = 'fa-apple';
      } else if (ua.indexOf('Linux') !== -1 || ua.indexOf('linux') !== -1 || ua.indexOf('Ubuntu') !== -1) {
        platform = 'fa-linux';
      }
    }
    return platform;
  }, []);

  return (
    <button
      style={props.style}
      className={cx('slds-button slds-button--raiderio-gradient', props.className)}
      onClick={props.onClick}
    >
      <i className={cx('slds-m-right--x-small fa-brands', platformIcon)} />
      {t('nav:main.download-client-and-addon')}
    </button>
  );
};
